import { Box } from '@mui/material';

export const Inv = () => {
    return <Box sx={{ flex: 1 }}>INV</Box>;
};
